import WelcomeNotification from './WelcomeNotification';
import ClientBooking from './ClientBooking';
import NewClientDeliveryNotification from './NewClientDeliveryNotification';
import ClientMessage from './ClientMessage';
import UserRequestedWaitlist from './UserRequestedWaitlist';
import ClientReview from './ClientReview';
import ClientReschedule from './ClientReschedule';
import ScheduleGapFill from './ScheduleGapFill';
import MailingAddressNotification from './MailingAddressNotification';
import VerificationDetailsNotification from './VerificationDetailsNotification';
import ApptAddCreditCard from './ApptAddCreditCard';
import VirtualAppointmentNotification from './virtualAppointments/VirtualAppointmentNotification';
import ProductSalesNotification from './productSales/ProductSalesNotification';
import InstaSyncNotification from './InstaSyncNotification';
import VirtualServiceNotification from './virtualServices/VirtualServiceNotification';
import NcdAnnouncementNotification from './NcdAnnouncementNotification';
import SmartPricingAnnouncementNotification from './SmartPricingAnnouncementNotification';
import AddClientNotification from './AddClientNotification';
import ProfileFeedbackNotification from './ProfileFeedbackNotification';
import SearchBoostNotification from './SearchBoostNotification';
import SearchBoostEligibilityNotificationContainer from './SearchBoostEligibilityNotification';
import ExtendSearchBoostEligibilityNotification from './ExtendSearchBoostEligibilityNotification';
import AmbassadorToolkitNotification from './AmbassadorToolkitNotification';
import ManageGoalNotification from './ManageGoalNotification';
import ServiceInteractionNotification from './ServiceInteractionNotification';
import FirstSPClientApptBookingNotification from './FirstSPClientApptBookingNotification';
import MarketingHubNotification from './MarketingHubNotification';
import SearchRankNotificationContainer from './SearchRankNotification';
import NcdNonPaymentAppointmentNotification from './NcdNonPaymentAppointmentNotification';
import NcdCancellationPolicyNotificationContainer from './NcdCancellationPolicyNotification';
import NcdPaymentAppointmentNotification from './NcdPaymentAppointmentNotification';
import ClientCardAuthSuccessNotification from './ClientCardAuthSuccessNotification';
import AppointmentCancelledNotification from './AppointmentCancelledNotification';

/**
 * Contains mappings between notification types
 * and their react components
 * @type {Object}
 */

const componentMap = {
  client_appt_booking: {
    type: ClientBooking,
  },
  ncd_client_insight: {
    type: NewClientDeliveryNotification,
  },
  client_review: {
    type: ClientReview,
  },
  client_appt_reschedule: {
    type: ClientReschedule,
  },
  client_appt_schedule_gap_fill: {
    type: ScheduleGapFill,
  },
  client_message: {
    type: ClientMessage,
  },
  need_mailing_address: {
    type: MailingAddressNotification,
  },
  need_verification_details: {
    type: VerificationDetailsNotification,
  },
  welcome: {
    type: WelcomeNotification,
  },
  appt_without_cc: {
    type: ApptAddCreditCard,
  },
  user_requested_waitlist: {
    type: UserRequestedWaitlist,
  },
  virtual_appointment_education: {
    type: VirtualAppointmentNotification,
  },
  virtual_services_education: {
    type: VirtualServiceNotification,
  },
  product_sales_education: {
    type: ProductSalesNotification,
  },
  insta_sync: {
    type: InstaSyncNotification,
  },
  ncd_announcement: {
    type: NcdAnnouncementNotification,
  },
  smart_pricing_announcement: {
    type: SmartPricingAnnouncementNotification,
  },
  search_boost: {
    type: SearchBoostNotification,
  },
  add_client_notification: {
    type: AddClientNotification,
  },
  profile_feedback: {
    type: ProfileFeedbackNotification,
  },
  search_boost_eligibility: {
    type: SearchBoostEligibilityNotificationContainer,
  },
  extend_search_boost_eligibility: {
    type: ExtendSearchBoostEligibilityNotification,
  },
  ambassador_toolkit_announcement: {
    type: AmbassadorToolkitNotification,
  },
  manage_goal: {
    type: ManageGoalNotification,
  },
  client_service_interaction: {
    type: ServiceInteractionNotification,
  },
  first_sp_client_appt_booking: {
    type: FirstSPClientApptBookingNotification,
  },
  marketing_hub_announcement: {
    type: MarketingHubNotification,
  },
  new_sr_stats_notification: {
    type: SearchRankNotificationContainer,
  },
  ncd_non_payment_appointment_notification: {
    type: NcdNonPaymentAppointmentNotification,
  },
  ncd_cancellation_policy: {
    type: NcdCancellationPolicyNotificationContainer,
  },
  ncd_appointment_paid_on_styleseat: {
    type: NcdPaymentAppointmentNotification,
  },
  client_card_auth_success: {
    type: ClientCardAuthSuccessNotification,
  },
  client_appt_cancel: {
    type: AppointmentCancelledNotification,
  },
  appointment_cancelled_provider: {
    type: AppointmentCancelledNotification,
  },
  appointment_cancelled_provider_no_show: {
    type: AppointmentCancelledNotification,
  },
};

/**
 * Look up react component by notification type
 * @param   {String} type  Notification type
 * @returns {Class}        React notification class
 */
export function getComponent(type) {
  return componentMap[type] || null;
}
